import React from 'react';
import { InAppSidebarItem } from './InAppSidebarItem';
import { VideoCard } from './VideoCard';
import { Icon } from '@itglue/kaseya-ui';

export function findIframes(index: any, dataVimeo: any, singleVideo: any) {
    let iframeWithoutAutopause = dataVimeo[index].iframe;

    if (!singleVideo) {
        let position = dataVimeo[index].iframe.search('title=0&amp;');

        iframeWithoutAutopause = dataVimeo[index].iframe.slice(0, position) + 'background=1&amp;autoplay=0&amp;' +
            dataVimeo[index].iframe.slice(position + ' background=1&amp;autoplay=0&amp; '.length, dataVimeo[index].iframe.length);
    }

    return { __html: iframeWithoutAutopause };
}

function SidebarReturnButton({ handleReturn }: any) {
    return (
        <div className='itc-video-single-sidebar__return'
            onClick={handleReturn}>
            <div className='itc-back-to-tutorials'>
                <Icon fw regular className='itc-video-single__chevron' name='chevron-left'/>
                <span> {'Back to Tutorials'} </span>
            </div>
        </div>
    );
}

export function InAppSidebar ( { tags, tagColors, videosAndTags, handleClickSidebar, handleVideoClick,
    handleReturn, singleVideoView, dataVimeo, active, size, item }: any ) {
    let sidebarType = '';

    if (size) {
        sidebarType = '-small';
    }

    return (
        <div className={'in-app-videos__sidebar in-app-videos' + sidebarType + '__sidebar'}>
            { !singleVideoView && <>
                <InAppSidebarItem item={('All')} onClick={handleClickSidebar}
                    active={active}
                    tagActive={item}/>
                { tags?.map((tag: any, index: any) => {
                    return (
                        <InAppSidebarItem key={index} item={tag} onClick={handleClickSidebar} active={active}
                            tagActive={item}/>
                    );
                })
                }
            </> }
            { singleVideoView && <>
                <div className='itc-video-single-sidebar__header'>
                    <SidebarReturnButton handleReturn={handleReturn}/>
                    <span className='itc-suggested-videos'> {'Suggested Videos'} </span> </div>
                <div className='itc-videos__single-video-sidebar'>
                    { videosAndTags?.map((video: any, index: any) => {
                    // only display tag once per group of 3 with same tag name
                        let tagGroupHeader = videosAndTags[index].tag !== videosAndTags[index - 1]?.tag;

                        return (
                            <div className={'itc-videos-small'} onClick={(e) => handleVideoClick(e, video.video, video.index)} key={ index }>
                                {tagGroupHeader && <div className={'itc-video-small__tag-box'}>
                                    <span key={index} className={'itc-video-small__tag itc-video__tag--' +
                                    tagColors[video.tag]}>{video.tag}</span>
                                </div>}
                                <VideoCard
                                    key={index}
                                    onClick={(e: any) => handleVideoClick(e, video.video, video.index)}
                                    tags={[video.tag]}
                                    sidebar={true}
                                    className={'itg-video-small'}
                                    tagColors={tagColors}
                                    description={null}
                                    small={true}
                                    title={ video.video.name }
                                    iframe={findIframes(video.index, dataVimeo, false)}/>
                            </div>
                        );
                    })}
                </div>
            </> }
        </div>
    );
}